// src/data/siteData.js
//
// Saara dummy / static content yahan se aata hai.
// Future mein backend/API connect karte waqt mostly isi file
// ke data ko API response se replace kiya ja sakta hai.
//
// Images src/assets/images mein hain, is liye imported hain.
// Agar koi image public folder mein ho to usay direct:
// "/image-name.png"
// ki form mein use kiya ja sakta hai.


// ============================================================
// IMAGE IMPORTS
// ============================================================

import heroBg from "../assets/images/1st-banner.png";
import bubblesBg from "../assets/images/hero-bg.png";
import statsBg from "../assets/images/product-banner-2.png";

import serumImg from "../assets/images/toner1.png";
import facewashImg from "../assets/images/facewash.png";
import haircareImg from "../assets/images/haircare.png";

import qrImg from "../assets/images/qr.png";


// ============================================================
// SOCIAL LINKS
// ============================================================

export const SOCIAL_LINKS = {
  facebook: "https://www.facebook.com/yourcare.pk",

  instagram: "https://www.instagram.com/yourcare.pk",

  tiktok: "https://www.tiktok.com/@yourcare.pk",
};


// ============================================================
// NAVIGATION LINKS
// ============================================================
//
// Navbar isi array ko use karta hai.
//
// Home          -> /
// Products      -> /products
// Services      -> /services
// About Us      -> /about
// Why Choose Us -> /why-us
// Contact Us    -> /contact
//
// ============================================================
export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Products", path: "/products" },
  { label: "Services", path: "/services" },
  { label: "About Us", path: "/about" },
  { label: "Why Choose Us", path: "/why-us" },
  { label: "Contact Us", path: "/contact" },
];
// ============================================================
// TOP ANNOUNCEMENT / BANNER
// ============================================================

export const ANNOUNCEMENT_TEXT =
  "Welcome to Your Care (Ultimate 4-in-1 Skin Revitalizing Serum) is available now, You can order now.";


// ============================================================
// HERO SECTION
// ============================================================

export const HERO_CONTENT = {
  title: "Welcome to Your Care",

  tagline: "Care that Clicks",

  ctaLabel: "Shop Now",

  ctaLink: "/products",

  bgImage: heroBg,
};


// ============================================================
// FEATURE BAR
// ============================================================

export const FEATURE_BAR = [
  {
    icon: "heart",
    label: "For You",
  },

  {
    icon: "flask",
    label: "Clinically Tested",
  },

  {
    icon: "star",
    label: "Effective",
  },

  {
    icon: "flag",
    label: "Made in Pakistan",
  },
];


// ============================================================
// MISSION & VISION
// ============================================================

export const MISSION_VISION = [
  {
    number: "01",

    title: "Our Mission",

    text:
      "To develop science-backed skincare products that combine innovation, quality, and nature to improve skin health and confidence.",
  },

  {
    number: "02",

    title: "Our Vision",

    text:
      "To become Pakistan's leading science-based skincare brand recognized for quality, innovation, and trust.",
  },
];


// ============================================================
// CARE THAT CLICKS BANNER
// ============================================================

export const CARE_CLICKS_BANNER = {
  heading: "CARE THAT CLICKS",

  bgImage: bubblesBg,
};


// ============================================================
// STATS SECTION
// ============================================================

export const STATS_SECTION = {
  heading: "Premium Skincare Excellence",

  bgImage: statsBg,

  stats: [
    {
      value: 8374,
      suffix: "+",
      label: "Bottles Shipped",
    },

    {
      value: 6108,
      suffix: "+",
      label: "Laboratory Research Hours",
    },

    {
      value: 4728,
      suffix: "+",
      label: "Skincare Consultations",
    },

    {
      value: 49,
      suffix: "+",
      label: "Cities Nationwide Served",
    },
  ],
};


// ============================================================
// PRODUCTS
// ============================================================

export const PRODUCTS = [

  // ----------------------------------------------------------
  // PRODUCT 1
  // ----------------------------------------------------------

  {
    id: "p1",

    name: "Ultimate 4-in-1 Skin Revitalizing Serum",

    price: 2500,

    currency: "Rs.",

    badge: "NEW IN",

    // available | coming-soon
    status: "available",

    image: serumImg,

    features: [
      "Vitamin C",
      "Lightening",
      "Antiaging",
      "Moisturising",
    ],
  },


  // ----------------------------------------------------------
  // PRODUCT 2
  // ----------------------------------------------------------

  {
    id: "p2",

    name: "Whitening Facewash",

    price: null,

    currency: "Rs.",

    badge: "COMING SOON",

    // available | coming-soon
    status: "coming-soon",

    image: facewashImg,

    features: [
      "Brightens Skin",
      "Foam Toner",
      "Deep Cleansing",
      "Hydrates Skin",
    ],
  },


  // ----------------------------------------------------------
  // PRODUCT 3
  // ----------------------------------------------------------

  {
    id: "p3",

    name: "Haircare Serum",

    price: null,

    currency: "Rs.",

    badge: "COMING SOON",

    // available | coming-soon
    status: "coming-soon",

    image: haircareImg,

    features: [
      "Strengthens Hair",
      "Reduces Hairfall",
      "Nourishes Scalp",
    ],
  },

];


// ============================================================
// WHY CHOOSE US
// ============================================================
//
// Why Choose Us page ke tamam static/dummy data yahan hai.
//
// Hero image:
// /bn2.png
//
// Main content image:
// /arp4.jpeg
//
// Ye dono images public folder mein honi chahiye:
//
// public/
// ├── bn2.png
// └── arp4.jpeg
//
// ============================================================

export const WHY_CHOOSE_US = {

  // ----------------------------------------------------------
  // HERO
  // ----------------------------------------------------------

  hero: {
    title: "WHY CHOOSE US",

    subtitle: "Science-backed Skincare Excellence",

    image: "/bn2.png",
  },


  // ----------------------------------------------------------
  // MAIN SECTION
  // ----------------------------------------------------------

  intro: {
    label: "WHY YOURCARE",

    heading: "Why Choose YourCare?",

    image: "/arp4.jpeg",
  },


  // ----------------------------------------------------------
  // WHY CHOOSE US POINTS
  // ----------------------------------------------------------

  reasons: [

    {
      number: "01",

      title: "Science-based formulations",

      text:
        "Developed through rigorous scientific research and verified testing in Chemistry Research Laboratories.",
    },


    {
      number: "02",

      title: "Premium active ingredients",

      text:
        "Carefully selected natural compounds combined with clinically recognized actives for real results.",
    },


    {
      number: "03",

      title: "Suitable for all skin types",

      text:
        "Formulated to be gentle, non-irritating, and effective for everyday self-care.",
    },


    {
      number: "04",

      title: "Lightweight and non-greasy formulations",

      text:
        "Fast-absorbing textures that provide deep hydration without feeling heavy or blocking pores.",
    },


    {
      number: "05",

      title: "High-quality manufacturing standards",

      text:
        "Produced under strict quality control to guarantee safety, quality, and consistency.",
    },


    {
      number: "06",

      title: "Customer-focused service",

      text:
        "Dedicated support and skincare guidance tailored to your personal goals and skin journey.",
    },


    {
      number: "07",

      title: "Continuous research and innovation",

      text:
        "Always researching to bring you the latest breakthroughs in science-backed skincare.",
    },

  ],
};


// ============================================================
// FOOTER CONTENT
// ============================================================

export const FOOTER_CONTENT = {

  description:
    "Your trusted destination for premium skincare, organic beauty essentials, and everyday self-care products.",

  address:
    "NUST, H-12 Islamabad, Pakistan",

  phone:
    "03006005249",

  email:
    "support@yourcare.pk",

  qrImage:
    qrImg,

  year:
    2026,
};